import ReactDOM from "react-dom";
import React from "react";

export class ModalHelper {
    public static createModal<ChildProps>(Modal: React.ComponentClass<ModalDialogProps>): (p?: ChildProps) => Promise<boolean> {
        let promise: Promise<boolean>,
            resolve: Function

        const targetElement = $("<div>");
        $("body").append(targetElement);
        const root = ReactDOM["createRoot"](targetElement[0]);

        const init = () => {
            promise = new Promise((res) => {
                resolve = res;
            });
        };
        const removeDialog = () => {
            root.unmount(targetElement[0]);
            targetElement[0].remove();
        }
        const onOk = () => {
            removeDialog();
            resolve(true);
        };

        const onCancel = () => {
            removeDialog();
            resolve(false);
        };

        return (props?: ChildProps): Promise<boolean> => {
            init();
            root.render(<Modal onCancel={onCancel} onOk={onOk} {...props} />);
            return promise;
        };
    }
}


export interface ModalDialogProps {
    onOk: () => void;
    onCancel: () => void;
    onBeforeOk?: () => boolean;
}